import { render, staticRenderFns } from "./DataSourceChoose.vue?vue&type=template&id=19031d6a"
import script from "./DataSourceChoose.vue?vue&type=script&lang=js"
export * from "./DataSourceChoose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports